import {Component, OnDestroy} from "@angular/core";
import {Router} from "@angular/router";
import {AuthentService} from "../../services/authent.service";
import {BusinessRight} from "../../model/business-right";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {Business} from "../../model/business";
import {FamilyAlbum} from "../../model/family-album";
import {BusinessService} from "../../services/data/business.service";
import {CurrentEventService} from "../../services/communication/currentEventService";
import {Subscription} from "rxjs";

@Component({
  selector: 'event-page',
  template: require('./event-page.component.html'),
  styles: [
    require('./event-page.component.scss')
  ]
})

export class EventPageComponent implements OnDestroy {

  business:Business = new Business();

  // album creation
  model: FamilyAlbum = new FamilyAlbum();
  submitted = false;

  date:number;
  isPublic:boolean = false;
  isDateValid:boolean = false;

  myDatePickerOptions = {
    todayBtnTxt: 'Aujourd\'hui',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    inline: false,
    locale: 'fr',
    selectionTxtFontSize: '16px'
  };

  userRight: BusinessRight = new BusinessRight();

  private businessSubscription: Subscription = null;

  ngOnDestroy(): void {
    if(this.businessSubscription!=null) {
      this.businessSubscription.unsubscribe();
    }
  }

  constructor(private router:Router, private authent:AuthentService,
              private currentBusinessService:CurrentBusinessService,
              private businessService: BusinessService, private currentEventService: CurrentEventService) {
    if (currentBusinessService.currentBusiness != null && currentBusinessService.currentBusiness.logoPath != null) {
      this.business = currentBusinessService.currentBusiness;

    } else {
      this.businessSubscription = currentBusinessService.businessChange$.subscribe(
        business => {
          this.business = business;
        }
      );
    }

    if (authent.getRight() == null) {
      authent.userRight$.subscribe(
        right => {
          this.userRight = right;
        }
      );
    } else {
      this.userRight = authent.getRight();
    }
  }

  canCreate():boolean {
    let right:BusinessRight = this.authent.getRight();

    if (right != null) {
      return this.authent.getRight().canCreate;
    }

    return false;
  }

  onDateChanged(event:any) {
    if (event.formatted != undefined && event.formatted != "") {
      this.isDateValid = true;
      this.date = event.epoc*1000;
    } else {
      this.isDateValid = false;
    }
  }

  createEvent() {
    this.model.date = this.date;

    this.businessService.createEvent(this.currentBusinessService.currentBusiness.id, this.model)
        .subscribe(
            event => {
              this.currentEventService.changeEvent(event);
              this.router.navigateByUrl('/event/'+event.id+'?a=c');
            },
            error => {
              console.log(error)
            }
        );
  }

  creationClose() {
    this.model = new FamilyAlbum();
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/event-page.component.ts